import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { ScreensQuestionResource } from '@Components/mras/core';

@Component({
    selector: 'jhi-boolean-input',
    templateUrl: './boolean-input.component.html'
})
export class BooleanInputComponent {
    @Input()
        question: ScreensQuestionResource;
    @Input()
        summaryMode: boolean;
    @Input()
        value: any;

    _valueText: string;
    @Input()
    set valueText(val: string) {
        if (val?.toString() === 'true' || val === 'Yes') {
            this._valueText='Yes';
        } 
        else if (val?.toString() === 'false' || val === 'No') {
            this._valueText='No';
        }else{
            this._valueText = val;
        }
    }
    get valueText() { return this._valueText; }
    @Output()
        valueChange = new EventEmitter<any>();
    @Output()
        action = new EventEmitter<any>();
    @Input()
        nullable = true;
    
    form: UntypedFormGroup;
    selectedValue: string;

    answerValues = ["Yes", "No"];

    constructor(private fb: UntypedFormBuilder) {
        
    }

    onClick(value: boolean) {        
        if (this.question.invalid) {
            this.question.invalid = false;
        }
        
        let answerHasChanged = false;
        if (this.value !== value) {
            answerHasChanged = true;
        }   

        this.value = value;
        this.valueChange.emit(this.value);
        this.action.emit(answerHasChanged);
    }

    onRadioChange(event: MatRadioChange) {
        if (event.value === "No") {
            this.onClick(false);
        }
        if (event.value === "Yes") {
            this.onClick(true);
        }
    }
}
